import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";

// ─── S3 Configuration ────────────────────────────────────────────────────────

const S3_BUCKET   = "invent-co-new";
const S3_FOLDER   = "HMangement";
const S3_BASE_URL = "https://s3-noi.aces3.ai";

const s3Client = new S3Client({
  region: "us-east-1",
  credentials: {
    accessKeyId:     "AKIAFBC97UM4I3ILWTIKQ",
    secretAccessKey: "vMUNWcZvMesuFfmUwdUYnsaOr1pp38wu8nOon8eb",
  },
  endpoint:       "https://s3-noi.aces3.ai/",
  forcePathStyle: true,
});

// ─── Helpers ─────────────────────────────────────────────────────────────────

/**
 * Produce a unique key-safe filename: <original-base>_<timestamp>.<ext>
 * e.g. "my photo.jpg" → "my_photo_1713084000000.jpg"
 */
const buildFileName = (originalName) => {
  const dotIdx = originalName.lastIndexOf(".");
  const ext    = dotIdx !== -1 ? originalName.slice(dotIdx + 1) : "bin";
  const base   = (dotIdx !== -1 ? originalName.slice(0, dotIdx) : originalName)
    .replace(/[^a-zA-Z0-9_-]/g, "_")
    .slice(0, 50);
  return `${base}_${Date.now()}.${ext}`;
};

// ─── Core upload function ─────────────────────────────────────────────────────

/**
 * Upload a File directly to S3 and return the public URL.
 *
 * @param {File}     file              - Native File object to upload.
 * @param {string}   [folder]          - S3 folder prefix (defaults to "HMangement").
 * @param {Function} [onProgress]      - Optional callback: ({ percent: number }) => void
 * @returns {Promise<string>}           - Full public URL:
 *                                        https://s3-noi.aces3.ai/invent-co-new/HMangement/<file-name>
 *
 * @example
 * // Inside a form submit handler
 * const url = await uploadToS3(file);
 * // → "https://s3-noi.aces3.ai/invent-co-new/HMangement/avatar_1713084000000.png"
 */
export const uploadToS3 = async (file, folder = S3_FOLDER, onProgress) => {
  if (!file || !(file instanceof File)) {
    throw new Error("uploadToS3: expected a File object");
  }

  const fileName = buildFileName(file.name);
  const key      = `${folder}/${fileName}`;

  const upload = new Upload({
    client: s3Client,
    params: {
      Bucket:      S3_BUCKET,
      Key:         key,
      Body:        file,
      ContentType: file.type || "application/octet-stream",
    },
  });

  if (typeof onProgress === "function") {
    upload.on("httpUploadProgress", ({ loaded, total }) => {
      if (total) onProgress({ percent: Math.round((loaded / total) * 100) });
    });
  }

  const result = await upload.done();

  // Prefer the Location from SDK response; fall back to manual construction.
  return (
    result.Location ||
    (result.Bucket && result.Key
      ? `${S3_BASE_URL}/${result.Bucket}/${result.Key}`
      : `${S3_BASE_URL}/${S3_BUCKET}/${key}`)
  );
};
